

import { Component, Prop, Vue } from "vue-property-decorator";
import { $getOperDayCached } from "@/api/mainPage/operDay/operDay";

@Component
export default class OperationDay extends Vue {

	@Prop({ type: Boolean, default: false })
	readonly isHeader!: boolean

	public isColor: boolean;

	public currentDay: string | null;

	public desserts: any[];

	constructor() {
		super();

		this.isColor = true;

		this.desserts = [];

		this.currentDay = null;
	}

	created() {
		this.initialize();
	}

	/**
	 * @returns {Object} date
	 * @returns {String} date.currentDate
	 * @returns {Boolean} date.isOpened
	 */

	protected initialize() {
		if (this.currentDay === null || this.currentDay === 'undefined') {
			$getOperDayCached().then((date: any) => {
				this.currentDay = date.currentDate;
				this.isColor = date.opened;
			});
		}
	}

};
